export default [
  {
    path: '/payment/:unique_code',
    name: 'secure-payment-form',
    component: () => import('@/views/pages/secure-payment-form/SecurePaymentForm.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/profile/:unique_code',
    name: 'lead-update-form',
    component: () => import('@/views/pages/lead-update-form/LeadUpdateForm.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/registration/validate/:unique_code',
    name: 'business-validation-form',
    component: () => import('@/views/pages/business-validation-form/BusinessValidationForm.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/registration/files/:unique_code',
    name: 'business-company-files',
    component: () => import('@/views/pages/business-validation-form/BusinessCompanyFiles.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/debt-solution/:unique_code',
    name: 'debt-solution-pdf',
    component: () => import('@/views/pages/debt-solution-pdf/DebtSolutionPdf.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/digital-business-card/preview/:unique_code/:slug?',
    name: 'digital-business-card-preview',
    component: () => import('@/views/pages/digital-business-card/DigitalBusinessCardMain.vue'),
    meta: {
      layout: 'full',
      role: 'company',
    },
  },
  {
    path: '/digital-business-card/view/:unique_code/:slug?',
    name: 'digital-business-card-view',
    component: () => import('@/views/pages/digital-business-card/DigitalBusinessCardMain.vue'),
    meta: {
      layout: 'full',
      role: 'client',
    },
  },
]
